import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@atoms/Button';
import { goToSection } from '@/utils/scrollToSection';

export function MarketingCtaBand() {
  const navigate = useNavigate();

  return (
    <section className="bg-slate-900 py-16 md:py-20">
      <div className="section-container text-center">
        <h2 className="text-3xl font-bold tracking-tight text-white md:text-4xl">
          Toptan tedarik sürecinizi dijitalleştirin
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-slate-400 md:text-lg">
          Binlerce restoran ve toptancının güvendiği platforma katılın. Hemen başlayın, farkı yaşayın.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button size="lg" onClick={() => navigate('/login')}>
            Hemen Başlayın
            <ArrowRight className="h-4 w-4" />
          </Button>
          <Button size="lg" variant="outlineLight" onClick={() => goToSection(navigate, 'wholesalers')}>
            Toptancıları İncele
          </Button>
        </div>
      </div>
    </section>
  );
}
